export interface BasicResponse {
  errors: [{
    code: number;
    message: string;
    detail: string;
  }];
  status: string;
  summary: string;
  obj: any;
}


export namespace BasicResponse {
  export function isBasicResponse(obj: any): obj is BasicResponse {
    if ('errors' in obj ) {
      return 'code' in obj.errors;
    } else {
      return false;
    }
  }
}

